/**
 * @generated SignedSource<<f78fae156465aff0715c77f48decac65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PlaylistDetailsDeleteMutation$variables = {
  id: string;
};
export type PlaylistDetailsDeleteMutation$data = {
  readonly deletePlaylist: {
    readonly id: string;
  };
};
export type PlaylistDetailsDeleteMutation = {
  response: PlaylistDetailsDeleteMutation$data;
  variables: PlaylistDetailsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RemovedPlaylist",
    "kind": "LinkedField",
    "name": "deletePlaylist",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PlaylistDetailsDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlaylistDetailsDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d3e6d8c79f146aaab1d586126a390d40",
    "id": null,
    "metadata": {},
    "name": "PlaylistDetailsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PlaylistDetailsDeleteMutation(\n  $id: ID!\n) {\n  deletePlaylist(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac6cf1c58c7b6d651dff0ebe19479a23";

export default node;
